import { ICustomerBalance } from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class CustomerBalance implements ICustomerBalance {
  customerId!: string;
  balance!: number;
  @Type(() => Date)
  overdueDate!: Date | null;
  overdueAmount!: number;
}
